import React, { FC } from "react";

import Campaign from "components/BeAmplified/Campaigns/Organic/View/AutoFollower";
import { firestore } from "firebase-tools/firebase";
import useDocumentSubscriber from "hooks/useDocumentSubscriber";
import { SocialMediaPlatform } from "../SelectCampaign";

type CampaignType = {
  uid?: string;
  path: string;
  platform?: SocialMediaPlatform;
};

const CampaignPage: FC<CampaignType> = ({ uid, platform }) => {
  let collectionName = "twitter-campaigns";
  if (platform) {
    switch (platform) {
      case SocialMediaPlatform.Instagram:
        collectionName = "instagram-autofollow-campaigns";
        break;
      default:
        collectionName = "twitter-campaigns";
        break;
    }
  }
  const campaignsRef = firestore.collection(collectionName).doc(uid);

  const campaign = useDocumentSubscriber({ ref: campaignsRef }).document;

  return (
    <div>
      {campaign?.status && (
        <Campaign
          campaign={campaign}
          platform={platform || SocialMediaPlatform.Twitter}
          collectionName={collectionName}
        />
      )}
    </div>
  );
};

export default CampaignPage;
